<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {

    components: { Multiselect, UploadFile },

    props: {

    },

    data() {
        return {
            trackBy: 'id',

            provider: null,
            initProvider: [],
            providers_option: [],

            language: null,
            initLanguages: [],
            languages_option: [],

        }
    },

    watch: {
        initProvider: {
            immediate: true,
            handler(values) {
                this.provider = this.providers_option.filter(x => values.includes(x['operator_uuid']));
                this.provider = this.provider[0];
            }
        },

        initLanguages: {
            immediate: true,
            handler(values) {
                this.language = this.languages_option.filter(x => values.includes(x[this.trackBy]));
                this.language = this.language[0];
            }
        },

        provider: {
            immediate: true,
            async handler(values) {

                if(this.provider){
                    this.$parent.stt_params.provider = this.provider.operator_code ? this.provider.operator_code : null;
                    this.$parent.stt_params.provider_uuid = this.provider.operator_uuid ? this.provider.operator_uuid : null;

                    let filter = {
                        'operator_uuid' : this.$parent.tts_params.provider_uuid,
                        'product_code'  : this.$parent.tts_params.product_code,
                    }

                    let data_send = {
                        'where' : JSON.stringify(filter)
                    }

                    await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_LIST', data_send);
                    if(this.operators_tariffs_list_data && this.operators_tariffs_list_data[0]){
                        this.languages_option = this.get_options(this.operators_tariffs_list_data[0].languages);
                        this.initLanguages = [this.$parent.stt_params.language];
                    }

                } else if(values === null) {
                    this.voices_id_option = [];
                    this.languages_option = [];
                    this.language = null;
                    this.$parent.stt_params.provider = null;
                    this.$parent.stt_params.provider_uuid = null
                }
            }
        },

        language: {
            immediate: true,
            handler(values) {
                if(this.language && this.language.id) {
                    this.$parent.stt_params.language = this.language.id ? this.language.id : null;
                } else if(values === null) {
                    this.$parent.stt_params.language = null;
                }
            }
        }
    },

    computed: {
        operators_tariffs_list_data(){
            return this.$store.getters['operatorsTariffs/GET_OPERATORS_TARIFFS_LIST_DATA'];
        }
    },

    async mounted() {

        let data_send = {
            'filter'     : this.$parent.params.stt_params.product_code ? this.$parent.params.stt_params.product_code : this.$parent.stt_params.product_code,
            'filterOn'   : JSON.stringify(['product_code']),
            'get_fields' : JSON.stringify(['operator_code', 'operator_name', 'operator_uuid', 'product_code']),
            'groupBy'    : JSON.stringify(['operator_code', 'operator_name', 'operator_uuid', 'product_code']),
        }

        await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_LIST', data_send);

        this.providers_option = this.operators_tariffs_list_data;

        if(this.$parent.params.stt_params && this.$parent.params.stt_params.provider_uuid) {
            this.initProvider = [this.$parent.params.stt_params.provider_uuid];
        }

    },

    methods: {
        get_options(arr = []){
            let arr_options = [];
            let name_translate = {
                'ru-RU'   : 'Русский',
                'kk-KK'   : 'Казахский',
            }

            arr.forEach(el => {
                arr_options.push({
                    id: el,
                    name: name_translate[el] ? name_translate[el] : el
                });
            })
            return arr_options;
        }
    }
}
</script>

<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-xl-6">
                <b-form-group
                    label="Переменная источник"
                    label-for="stt_params_variable_name"
                >
                    <b-form-input
                        id="stt_params_source_variable"
                        v-model="$parent.stt_params.source_variable"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-sm-12 col-xl-6">
                <b-form-group
                    label="Переменная для сохранения результата"
                    label-for="stt_params_variable_name"
                >
                    <b-form-input
                        id="stt_params_variable_name"
                        v-model="$parent.stt_params.variable_name"
                    ></b-form-input>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-xl-6">
                <b-form-group
                    label="Провайдер"
                    label-for="provider"
                >
                    <multiselect
                        id="provider"
                        v-model="provider"
                        :options="providers_option"
                        placeholder="Выберите из списка"
                        selectLabel="Нажмите, чтобы выбрать"
                        deselectLabel="Нажмите, снять выделение"
                        label="operator_name"
                        track-by="operator_uuid"
                    ></multiselect>
                </b-form-group>
            </div>
            <div class="col-sm-12 col-xl-6" v-show="languages_option.length > 0">
                <b-form-group
                    label="Язык"
                    label-for="language"
                >
                    <multiselect
                        id="language"
                        v-model="language"
                        :options="languages_option"
                        placeholder="Выберите из списка"
                        selectLabel="Нажмите, чтобы выбрать"
                        deselectLabel="Нажмите, снять выделение"
                        label="name"
                        :track-by="trackBy"
                    ></multiselect>
                </b-form-group>
            </div>
        </div>
    </div>
</template>

